import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=2db5635b&scoped=true&"
import script from "./Hint.vue?vue&type=script&lang=ts&"
export * from "./Hint.vue?vue&type=script&lang=ts&"
import style0 from "./Hint.vue?vue&type=style&index=0&id=2db5635b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5635b",
  null
  
)

export default component.exports